import { render } from "./Products.vue?vue&type=template&id=a6be4f0a"
import script from "./Products.vue?vue&type=script&lang=ts"
export * from "./Products.vue?vue&type=script&lang=ts"
script.render = render

export default script